
<app-header *ngIf="(!router.url.includes('login')&&(!router.url.includes('Dashboard')))"></app-header>
<router-outlet></router-outlet>


